import { useEffect, useState } from "react";
import { Wind, Flame, BookCheck, Target, Smile } from "lucide-react";
import { http } from "@/lib/api";

const ITEMS = [
  { key: "mindful_minutes", label: "Mindful minutes", icon: Wind },
  { key: "streak_days", label: "Day streak", icon: Flame },
  { key: "lessons_completed", label: "Lessons", icon: BookCheck },
  { key: "accuracy", label: "Quiz accuracy", icon: Target, suffix: "%" },
  { key: "mood_lift", label: "Avg mood lift", icon: Smile, prefix: "+" },
];

export const StatsStrip = () => {
  const [stats, setStats] = useState(null);
  useEffect(() => { http.get("/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid="stats-strip">
      {ITEMS.map(({ key, label, icon: Icon, suffix = "", prefix = "" }) => (
        <div key={key} className="rounded-2xl bg-white/60 border border-[#E6DEC3] p-4">
          <Icon className="w-4 h-4 text-[#C87D53]" />
          <div className="mt-3 font-display text-2xl text-[#2C4A3E]" data-testid={`stat-${key}`}>
            {stats ? `${key === "mood_lift" && stats[key] < 0 ? "" : prefix}${stats[key]}${suffix}` : "–"}
          </div>
          <div className="text-xs uppercase tracking-widest text-stone-500 mt-1">{label}</div>
        </div>
      ))}
    </div>
  );
};
